import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './reducers/root'
import { setStoreRef } from './storeRef'

// configureStore automatically adds redux-thunk and Redux DevTools.
// Serializability check is disabled because the legacy reducers use
// Immutable.js Maps. These will be migrated to plain objects in a future phase.
const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

// Register with storeRef so auth.js can access the store without a
// circular static import (store → reducers → actions/login → auth → store).
setStoreRef(store)

export default store
